import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ALL_LABELS = ['Convives', 'Date', 'Heure', 'Salle', 'Infos'];

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
  // Dynamically pick labels based on totalSteps
  const labels = totalSteps === 5 ? ALL_LABELS : ALL_LABELS.filter(l => l !== 'Salle');
  
  return (
    <div className="flex items-center justify-center gap-2 px-4 py-3">
      {labels.map((label, i) => (
        <div key={i} className="flex items-center gap-2">
          <div className="flex flex-col items-center gap-1">
            <motion.div
              className={cn(
                'w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-colors',
                i < currentStep
                  ? 'bg-primary text-primary-foreground'
                  : i === currentStep
                  ? 'bg-primary text-primary-foreground ring-2 ring-primary/30 ring-offset-2'
                  : 'bg-muted text-muted-foreground'
              )}
              animate={i === currentStep ? { scale: [1, 1.1, 1] } : {}}
              transition={{ duration: 0.3 }}
            >
              {i < currentStep ? '✓' : i + 1}
            </motion.div>
            <span className={cn(
              'text-[10px] font-medium',
              i <= currentStep ? 'text-primary' : 'text-muted-foreground'
            )}>
              {label}
            </span>
          </div>
          {i < labels.length - 1 && (
            <div className={cn(
              'w-6 h-0.5 mb-4',
              i < currentStep ? 'bg-primary' : 'bg-muted'
            )} />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
